import { Component, OnInit } from '@angular/core';
import { FetchBalanceService } from './fetchBalance.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BusinessProfileService } from './business-profile.service';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  businessInfo: any;
  data: any[] = [];
  balance: any;
  numPages: any;
  imageSrc: string = '';
  oldValues: any;
  businessName!: any;
  phone!: any;
  email!: any;
  businessId!: number;
  businessPermission = false;
  profilePermission = false;

  constructor(
    public fetchBussinesBalance: FetchBalanceService,
    public sanitizer: DomSanitizer,
    private businessProfileService: BusinessProfileService,
    private activatedRoute: ActivatedRoute,
    private auth: AuthService
  ) { }

  async ngOnInit() {
    this.activatedRoute.params.subscribe(async a => {
      this.businessId = a['id'];
      this.fetchBussinesBalance.setParams({ bussinesId: a['id'] });
      const balanceObj = await this.fetchBussinesBalance.make();
      this.balance = balanceObj.calculatedBalance;

      this.businessProfileService.setParams({ bussinesId: a['id'] });
      const oldValues = await this.businessProfileService.make();
      this.businessInfo = oldValues;

      this.imageSrc = oldValues.Business.logo;
      this.businessName = oldValues.Business.name;
      this.email = oldValues.email;
      this.phone = oldValues.phone;
      this.businessPermission = await this.hasPermissionFor("Business");
      this.profilePermission = await this.hasPermissionFor("Profile")
    });
  }

  async hasPermissionFor(roleType: string) {
    const permissions = await this.auth.getPermissions();
    for (const perm of permissions) {
      const action = perm.action;
      if (action === `Crm.Update${roleType}`) {
        return true;
      }
    }
    return false;
  }

}
